// extracted by mini-css-extract-plugin
export default {"base":"FadeBorder_base__MoGz4"};